import { Box, Card, Stack, Divider, Typography, CircularProgress } from '@mui/material';

import useAuth from 'src/hooks/useAuth';
import useLocales from 'src/hooks/useLocales';

import { isWaitingOn } from './dashboardRun';
import DashboardSectionHeader from '../DashboardSectionHeader';
import DashboardWorkflowStatusItem from './DashboardWorkflowStatusItem';
import useDashboardWorkflowRuns from './hooks/useDashboardWorkflowRuns';

const RUN_LIMIT = 10;

export default function DashboardWorkflowStatus() {
  const { t } = useLocales();
  const { user } = useAuth();
  const { runs, isLoading, hasLoadFailed } = useDashboardWorkflowRuns(RUN_LIMIT);

  if (hasLoadFailed || (!isLoading && runs.length === 0)) {
    return null;
  }

  const waitingOnMe = runs.filter((run) => isWaitingOn(run, user?.email)).length;

  return (
    <Box>
      <DashboardSectionHeader localeText="dashboard.workflowRuns.title" />

      <Card sx={{ overflow: 'hidden' }}>
        {isLoading ? (
          <Stack sx={{ py: 4, alignItems: 'center' }}>
            <CircularProgress size={24} />
          </Stack>
        ) : (
          <>
            <Stack
              direction="row"
              sx={{ px: 2, py: 1.25, alignItems: 'center', justifyContent: 'space-between' }}
            >
              <Typography variant="overline" sx={{ color: 'text.secondary' }}>
                {t('dashboard.workflowRuns.subheader', { count: runs.length })}
              </Typography>

              {waitingOnMe > 0 && (
                <Typography variant="caption" sx={{ color: 'warning.dark', fontWeight: 600 }}>
                  {t('dashboard.workflowRuns.waitingOnMe', { count: waitingOnMe })}
                </Typography>
              )}
            </Stack>

            <Divider />

            <Stack divider={<Divider />}>
              {runs.map((run) => (
                <DashboardWorkflowStatusItem key={run.documentId} run={run} />
              ))}
            </Stack>
          </>
        )}
      </Card>
    </Box>
  );
}
